var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('span',[_vm._v("\n    Questions? Contact the SPC Staff at spcinfo@greenblue.org or 434.817.1424\n  ")])])}]

export { render, staticRenderFns }